type ErrorFallbackProps = {
  reset: () => void;
};

export function ErrorFallback({ reset }: ErrorFallbackProps) {
  return (
    <div role="alert" className="min-h-screen bg-main-900 px-4 flex items-center justify-center text-center text-white">
      <div className="max-w-md space-y-5 text-primary">
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Something went wrong</h1>
          <p className="text-sm">
            Please try loading this part of the page again.
          </p>
        </div>
        <button
          type="button"
          className="rounded-full bg-primary-1 px-6 py-3 text-sm font-medium transition-opacity hover:opacity-90"
          onClick={reset}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
